import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero__content">
          <div className="hero__badge">✨ 使用最先进的 AI 技术</div>
          <h1 className="hero__title">
            释放 AI 创造力
            <br />
            <span className="gradient-text">专业 AI 服务</span>
          </h1>
          <p className="hero__subtitle">
            通过我们的 AI 绘图定制、AI 写作服务和 AI Logo 生成工具，
            将您的创意转化为专业作品
          </p>
          <div className="hero__actions">
            <button className="btn btn--primary btn--large">立即开始</button>
            <button className="btn btn--outline btn--large">了解更多</button>
          </div>
          <div className="hero__stats">
            <div className="stat">
              <div className="stat__number">10K+</div>
              <div className="stat__label">用户使用</div>
            </div>
            <div className="stat">
              <div className="stat__number">50K+</div>
              <div className="stat__label">作品生成</div>
            </div>
            <div className="stat">
              <div className="stat__number">99%</div>
              <div className="stat__label">满意度</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;

